import React, { useEffect, useState } from 'react';
import ContentLoader from 'react-content-loader';
import { useHistory } from 'react-router-dom';
import {
	Pulse,
	DEVICES,
	getCurrentEnv,
	NetworkHelper,
	NavigationHelpers,
	Footer,
	Button,
	useDeviceType,
	fetchPropertyConfig
} from 'common-utilities';
import NProgress from 'nprogress';
import './style.scss';
import 'nprogress/nprogress.css';
import { EVENT_CATEGORY, REDIRECT_URL, PAYTM_URL } from '../../constants';

const ENV = getCurrentEnv();
NProgress.configure({ showSpinner: false });
function Home({ state }) {
	const DEVICE = useDeviceType();
	const [userDetails, setUserDetails] = useState();
	const history = useHistory();
	const [apiStatus, setApiStatus] = useState(NetworkHelper.API_STATUS.NOT_STARTED);
	const redirectPaytmDeepLink =
		sessionStorage && sessionStorage.getItem('REDIRECT_PAYTM_DEEPLINK');

	const responseHandler = response => {
		switch ((response || {}).responseCode) {
			case 'BE1400001':
			case 'BE1424016':
				setTimeout(() => {
					Pulse.push({
						event_action: 'email_add_success_page_loaded',
						event_category: EVENT_CATEGORY,
						screenName: '/email_add_link_valid'
					});
				});
				setUserDetails(response);
				setApiStatus(NetworkHelper.API_STATUS.SUCCESS);
				break;
			case 'BE1424010':
				sessionStorage.setItem('ERROR_HEADING', 'Email Already exists');
				sessionStorage.setItem('ERROR_TEXT', (response || {}).message);
				break;
			case 'BE1424011':
				sessionStorage.setItem('ERROR_HEADING', 'Link Expired');
				sessionStorage.setItem('ERROR_TEXT', (response || {}).message);
				break;
			case 'BE1424015':
			case 'BE1424009':
			case 'BE1426011':
				sessionStorage.setItem('ERROR_TEXT', (response || {}).message);
				break;
			default:
				history.push('/error');
				break;
		}
		if ((sessionStorage.getItem('ERROR_TEXT') || '').length > 0) {
			history.push('/error');
		}
	};
	const setConfigData = async () => {
		sessionStorage &&
			sessionStorage.setItem(
				'REDIRECT_PAYTM_DEEPLINK',
				await fetchPropertyConfig('redirectPaytmDeepLink')
			);
	};
	useEffect(() => {
		if (!state || state.code == null || state.code === '') return;
		const code = state.code;
		const claimMergeRequired = state.claimMergeRequired;
		setApiStatus(NetworkHelper.API_STATUS.INITIALIZED);
		sessionStorage.clear();
		NProgress.start({
			showSpinner: false
		});
		setConfigData();
		NetworkHelper.get(
			`${ENV}/um/activate?code=${code}&&claimMergeRequired=${claimMergeRequired}`
		)
			.then(data => {
				NProgress.done();
				responseHandler(data);
			})
			.catch(err => {
				NProgress.done();
				history.push('/error');
			});
	}, []);

	// Guard: avoid rendering main flow when state/code is missing
	if (!state || state.code == null || state.code === '') {
		return (
			<div className="homePageContainer">
				<div className="heading">Something went wrong</div>
			</div>
		);
	}

	return (
		<React.Fragment>
			<div className="homePageContainer">
				{apiStatus === NetworkHelper.API_STATUS.SUCCESS ? (
					<div className="heading">Email has been successfully added to your account</div>
				) : apiStatus === NetworkHelper.API_STATUS.INITIALIZED ? (
					<div className="heading" style={{ marginBottom: '20px' }}>
						Loading Please wait
					</div>
				) : null}
				{apiStatus === NetworkHelper.API_STATUS.SUCCESS ? (
					<div className="infoContainer">
						{(userDetails['name'] || '').length > 0 && (
							<div>
								<span>Name: </span>
								<span className="value">{userDetails['name']}</span>
							</div>
						)}
						{(userDetails['phone'] || '').length > 0 && (
							<div>
								<span>Mobile No.:</span>
								<span className="value">{userDetails['phone']}</span>
							</div>
						)}
						{(userDetails['email'] || '').length > 0 && (
							<div>
								<span>Email ID:</span>
								<span className="value">{userDetails['email']}</span>
							</div>
						)}
					</div>
				) : apiStatus === NetworkHelper.API_STATUS.INITIALIZED ? (
					<ContentLoader animate={true} width={200} viewBox="0 0 200 32">
						<rect x="0" y="4" rx="2" ry="2" width="200" height="8" />
						<rect x="0" y="20" rx="2" ry="2" width="120" height="8" />
					</ContentLoader>
				) : null}
				{DEVICE === DEVICES.DESKTOP && apiStatus === NetworkHelper.API_STATUS.SUCCESS ? (
					<div className="buttonContainer">
						<Button
							onClick={() => {
								Pulse.push({
									event_action: 'go_to_paytm_web_clicked',
									event_category: EVENT_CATEGORY,
									screenName: '/email_add_link_valid'
								});
								NavigationHelpers.redirectToPaytm(redirectPaytmDeepLink);
							}}
							oauth-id="goto_paytm_btn"
							variant="primary-btn"
						>
							Go to Paytm.com
						</Button>
					</div>
				) : DEVICE === DEVICES.MOBILE && apiStatus === NetworkHelper.API_STATUS.SUCCESS ? (
					<div className="mobileButtonContainer">
						<button
							className="button primary"
							onClick={() => {
								Pulse.push({
									event_action: 'go_to_paytm_app_clicked',
									event_category: EVENT_CATEGORY,
									screenName: '/email_add_link_valid'
								});
								NavigationHelpers.redirectToPaytm(redirectPaytmDeepLink);
							}}
							oauth-id="goto_paytm_btn"
						>
							Go to Paytm App
						</button>
					</div>
				) : null}
			</div>
			<Footer isMobile={DEVICE === DEVICES.MOBILE} />
		</React.Fragment>
	);
}
export default Home;
